import is from 'is_js';

// eslint-disable-next-line import/prefer-default-export
export const isRUCentre = (state, centreId) => {
  const centres = state.get('rootReducer').get('centres');
  const centre = centres && centres.get(centreId);
  if (! centre || is.not.string(centre.countryCode)) return;
  return centre.countryCode.toLowerCase() === 'ru';
};



// WEBPACK FOOTER //
// ./data/Centre/accessors.js